import React, { useContext, useEffect, useRef, useState } from "react";
import LYWOLogoSmall from "../assets/images/LYWOLogoSmall.svg";
import ArrowCircleLeftLogo from "../assets/images/arrow-circle-left.svg";
import logOut from "../assets/images/log-out.svg";
import arrowRight from "../assets/images/arrow-right-pagination.svg";
import { AppContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import GroupList from "./grouplist";
import { Form, Modal } from "react-bootstrap";
import JobList from "./JobList";
import job from "../../src/assets/images/jobs.png";
import job1 from "../../src/assets/images/jobss.png";
import sh from "../../src/assets/images/sh.png";
import AccessCode from "./AccessCode";
import sh1 from "../../src/assets/images/sho.png";
import di from "../../src/assets/images/digitals.png";
import dig from "../../src/assets/images/digitalss.png";
import TotalMarketing from "./TotalMarketing";

const SelfService = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const timeoutRef = useRef(null);

  const { setIsLogin, setAdminData, adminInitialData, openSideBar, setOpenSideBar, activeMenu, setActiveMenu, adminData } = useContext(AppContext);

  const [showCodeRespondent, setShowCodeRespondent] = useState("");
  const [companyDtls, setCompnayDtls] = useState({
    company: "",
    designation: "",
    position: "",
  });

  // const [openSideBar, setOpenSideBar] = useState(true);
  // const [activeMenu, setActiveMenu] = useState("grouplist");
  const [show, setShow] = useState(false);

  const handleClose = (e) => {
    e.preventDefault();
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const handleLogout = () => {
    localStorage.clear();
    setIsLogin(false);
    setAdminData(adminInitialData);
    navigate("/Login");
  };

  const resetTimeout = () => {

    const THREE_DAYS = 3 * 24 * 60 * 60 * 1000;
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {

      handleLogout();
    }, THREE_DAYS);
  };

  useEffect(() => {
    const activityEvents = [
      "mousedown",
      "mousemove",
      "keydown",
      "scroll",
      "touchstart",
    ];

    const handleActivity = () => {
      resetTimeout();
    };

    activityEvents.forEach((event) => {
      document.addEventListener(event, handleActivity);
    });

    resetTimeout();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      activityEvents.forEach((event) => {
        document.removeEventListener(event, handleActivity);
      });
    };
  }, []);

  const navigate = useNavigate();

  const toggleSidebar = () => {
    setOpenSideBar(!openSideBar);
  };




  const handleMenuClick = (menu) => {
    setActiveMenu(menu);
    setOpenSideBar(true);
  };

  const handleNavButtonClick = (menu) => {
    setActiveMenu(menu);
    setOpenSideBar(true);
  };

  return (
    <>
      <div className="canLisWrap">
        <div
          className="canLisSideBar"
          // style={{ display: openSideBar ? "block" : "none" }}
          style={{ display: "none" }}
        >
          <div className="canLisLogoArea">
            <a href="/">
              <img src={LYWOLogoSmall} className="canLisLogoStyle" alt="Logo" />
            </a>
          </div>
          <div className="sideBarMenuArea">
            <div
              className={`sideBarMenu ${activeMenu === "grouplist" ? "active" : ""
                }`}
              onClick={() => handleMenuClick("grouplist")}
            >
              <p>Group Lists</p>
            </div>
            <div
              className={`sideBarMenu ${activeMenu === "JobList" ? "active" : ""
                }`}
              onClick={() => handleMenuClick("JobList")}
            >
              <p>Job Description</p>
            </div>
            <div
              className={`sideBarMenu ${activeMenu === "TotalMarketing" ? "active" : ""
                }`}
              onClick={() => handleMenuClick("TotalMarketing")}
            >
              <p>Marketing</p>
            </div>
          </div>
          <div className="sideBarBottomBtn">
            <img
              src={ArrowCircleLeftLogo}
              className="sideBarLogoStyle"
              alt="Logo"
              onClick={toggleSidebar}
            />
          </div>
        </div>
        <div
          className={`canLisContentWrap ${!openSideBar ? "fullwidth" : null}`}
        >
          <div className="canLisNavBar">
            <div className="OrgArea">
              {!openSideBar && (
                <div>
                  <img
                    src={arrowRight}
                    onClick={toggleSidebar}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              )}
              <a href="/">
                <img
                  src={LYWOLogoSmall}
                  className="canLisLogoStyle"
                  alt="Logo"
                />
              </a>



              <div className="tab-buttons-container">

                <>
                  <button
                    className={`tab-button ${activeMenu === "grouplist" ? "active" : ""
                      }`}
                    onClick={() => handleNavButtonClick("grouplist")}
                    style={{
                      borderRadius: "0px",
                      display: "flex",
                      flexDirection: "column",
                    }}

                  >
                    {/* <img
                    src={activeMenu === "grouplist" ? sh : sh1}
                    width={17}
                    height={17}
                  /> */}
                    Posted Jobs
                  </button>
                  {
                    // adminData?.isHaveJd &&
                    <button
                      className={`tab-button ${activeMenu === "JobList" ? "active" : ""
                        }`}
                      onClick={() => handleNavButtonClick("JobList")}
                      style={{
                        borderRadius: "0px",
                        display: "flex",
                        flexDirection: "column",
                      }}

                    >
                      {/* <img
                    src={activeMenu === "JobList" ? job : job1}
                    width={17}
                    height={17}
                  /> */}
                      Job Drafts
                    </button>
                  }
                </>


                {/* <button
                  className={`tab-button ${
                    activeMenu === "TotalMarketing" ? "active" : ""
                  }`}
                  onClick={() => handleNavButtonClick("TotalMarketing")}
                  style={{
                    borderRadius: "0px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <img
                    src={activeMenu === "TotalMarketing" ? dig : di}
                    width={21}
                    height={21}
                  />
                  Marketing
                </button> */}
              </div>


              <p className="ms-5 mt-auto">
                {/* <nav>
                 
                {localStorage.getItem("admin") &&
                  JSON.parse(localStorage.getItem("admin")) !== "Admin" && (
                    <>
                      <li className="breadcrumb-item" style={{ cursor: "pointer" }} onClick={() => handleMenuClick("grouplist")}>
                        All Jobs
                      </li>
                      <li className="breadcrumb-item bread-active">
                        {showCodeRespondent}
                      </li>
                    </>
                  )}
              </ol>
            </nav> */}

              </p>

            </div>
            <div className="profileArea">
              <h5>{`${companyDtls?.designation ? companyDtls?.designation : "Admin"
                }`}</h5>
              <div>
                <img
                  src={logOut}
                  className="profileOptnIcon"
                  alt="logo"
                  onClick={handleLogout} style={{ cursor: "pointer" }}
                />
              </div>
            </div>
          </div>

          {activeMenu === "grouplist" && (
            <GroupList
              codeRespondendHandler={(code, designation, company, form) => {
                setShowCodeRespondent(code);
                setActiveMenu("respondentData");
                setCompnayDtls({
                  company: company,
                  designation: designation,
                  position: form,
                });
              }}
              clearCode={() => {
                setShowCodeRespondent("");
                setCompnayDtls({
                  company: "",
                  designation: "",
                  position: "",
                });
              }}
            />
          )}
          {activeMenu === "JobList" && <JobList
            codeRespondendHandler={(code, designation, company, form) => {
              setShowCodeRespondent(code);
              setActiveMenu("respondentData");
              setCompnayDtls({
                company: company,
                designation: designation,
                position: form,
              });
            }}
            clearCode={() => {
              setShowCodeRespondent("");
              setCompnayDtls({
                company: "",
                designation: "",
                position: "",
              });
            }}
          />}
          {
            activeMenu == 'respondentData' && <AccessCode
              respondendByCode={showCodeRespondent} companyDtls={companyDtls}
            />
          }
          {activeMenu === "TotalMarketing" && <TotalMarketing />}
        </div >
        <Modal show={show} onHide={handleClose} size="md">
          <Modal.Body>
            <p className="text-center mb-4" style={{ fontSize: "23px" }}>
              Are you sure to Logout?
            </p>
            <hr />
            <Form>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-white border mx-2"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button className="btnVldt" onClick={handleLogout}>
                  Confirm
                </button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </div >
    </>
  );
};

export default SelfService;
